module.exports = __webpack_public_path__ + "95f96850adca3db87f6000f89e606e15.svg";